import React from 'react';

interface ButtonGridLayoutProps {
  /** Elementos hijos (botones) */
  children: React.ReactNode;
  /** Número de columnas en el grid */
  columns?: 2 | 3 | 4;
  /** Espaciado entre elementos */
  gap?: 'small' | 'medium' | 'large';
  /** Clases CSS adicionales */
  className?: string;
}

/**
 * Componente de layout en grid para organizar botones cuadrados
 */
export const ButtonGridLayout: React.FC<ButtonGridLayoutProps> = ({
  children,
  columns = 2,
  gap = 'medium',
  className = ''
}) => {
  // Configuración de espaciado
  const gapConfig = {
    small: 'gap-3',
    medium: 'gap-4',
    large: 'gap-6'
  };

  // Configuración de columnas
  const columnConfig = {
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4'
  };

  return (
    <div className={`
      grid ${columnConfig[columns]} ${gapConfig[gap]}
      w-full
      ${className}
    `}>
      {children}
    </div>
  );
};